import React, { Component } from 'react';
import {injectIntl, intlShape} from 'react-intl';

// this Footer is only used for DE no session error page
export class NoSessionFooter extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const {intl} = this.props;
        return (
            <div id="de-paypal-footer" className="clearfix">
                <span className="pull-right">
                    <span id="cue-paypal-icon" className="pull-right" />
                </span>
            </div>
        );
    }
}

export default injectIntl(NoSessionFooter);
